import React from 'react';
import bg from '../../assets/background.jpg';
import LogoGovBr from '../../assets/govbr.png';
import Logo from '../../assets/logo-serprobots-big.png';
import Button from '../../components/@base/Button';
import styles from './Auth.module.css';
import PROVIDER_CONFIG from './Config';

/**
 * Painel de login do usuário
 * @param {*} props
 * @returns
 */
const Login = (props) => {
  const loginButtonHandler = (providerType) => {
    props.setShowLogin(false);
    props.setProviderAuth(providerType);
  };

  return (
    <div className={styles.Auth} style={{ backgroundImage: `url(${bg})` }}>
      <div className="side">
        <div><img src={Logo} alt="logo" /></div>
        <div>
          <form>
            <h2>
              <span>Realize o login para acessar o Serprobots</span>
              <span />
            </h2>
            <Button
              primary
              small
              onClick={() => loginButtonHandler(PROVIDER_CONFIG.login_unico.alias)}
            >
              Login Único SERPRO
            </Button>

{/*             <Button
              primary
              small
              onClick={() => loginButtonHandler(PROVIDER_CONFIG.govbr.alias)}
            >
              <span style={{ marginRight: 8 }}>Entrar com</span>
              <img src={LogoGovBr} alt="logo gov br" style={{ width: 60 }} />
            </Button> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
